import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const useWidgetInfo = () => {
	return useSelector((state) => state?.widgetInfo);
};

export const initialState = {};

export const widgetInfoSlice = createSlice({
	name: 'widgetInfo',
	initialState,
	reducers: {
		setWidgetInfo(state, action) {
			return {
				...state,
				...action.payload
			};
		}
	}
});

export const { setWidgetInfo } = widgetInfoSlice.actions;

export default widgetInfoSlice.reducer;
